var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.formOption.busy } },
    [
      _c(
        "a-form",
        {
          ref: "form",
          attrs: {
            form: _vm.form,
            "label-col": { span: 12 },
            "wrapper-col": { span: 12 },
          },
        },
        [
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "用户账号" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["userNo", _vm.rules.userNo],
                            expression: "['userNo', rules.userNo]",
                          },
                        ],
                        attrs: { disabled: _vm.editStatus },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "用户名称" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["userName", _vm.rules.userName],
                            expression: "['userName', rules.userName]",
                          },
                        ],
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "是否使用" } },
                    [
                      _c("a-switch", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["isUse", { valuePropName: "checked" }],
                            expression:
                              "['isUse',{ valuePropName: 'checked' }]",
                          },
                        ],
                        attrs: {
                          "checked-children": "是",
                          "un-checked-children": "否",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "是否系统用户" } },
                    [
                      _c("a-switch", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["isSystem", { valuePropName: "checked" }],
                            expression:
                              "['isSystem',{ valuePropName: 'checked' }]",
                          },
                        ],
                        attrs: {
                          disabled: "",
                          "checked-children": "是",
                          "un-checked-children": "否",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "所属部门" } },
                    [
                      _c("a-tree-select", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["deptId", _vm.rules.deptId],
                            expression: "['deptId',rules.deptId]",
                          },
                        ],
                        attrs: {
                          "allow-clear": "",
                          "dropdown-style": {
                            maxHeight: "300px",
                            overflow: "auto",
                          },
                          treeData: _vm.treeData,
                          replaceFields: {
                            children: "children",
                            title: "deptName",
                            key: "deptId",
                            value: "deptId",
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "邮箱" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["email", _vm.rules.email],
                            expression: "['email', rules.email]",
                          },
                        ],
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "手机号" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["mobile", _vm.rules.phone],
                            expression: "['mobile', rules.phone]",
                          },
                        ],
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "头像",
                        "label-col": { span: 4 },
                        "wrapper-col": { span: 20 },
                      },
                    },
                    [
                      _c("uploader", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["headImg"],
                            expression: "['headImg']",
                          },
                        ],
                        attrs: { num: 1, accept: "image/*" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "备注",
                        "label-col": { span: 4 },
                        "wrapper-col": { span: 20 },
                      },
                    },
                    [
                      _c("a-textarea", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["remark", _vm.rules.remark],
                            expression: "['remark', rules.remark]",
                          },
                        ],
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-tabs",
        [
          _c(
            "a-tab-pane",
            { key: "1", attrs: { tab: "角色", forceRender: true } },
            [
              _c("roleTable", {
                ref: "roleTable",
                attrs: { rowId: _vm.rowId },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-space",
        { staticClass: "a-form-btn-box" },
        [
          _c(
            "a-button",
            {
              on: {
                click: function ($event) {
                  return _vm.endEdit("cancelled")
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "a-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm._save()
                },
              },
            },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }